import { getAutocompletion } from "./getAutocompletion.js";
import { tsFacet } from "../facet/tsFacet.js";
/**
 * Create a `CompletionSource` that queries
 * the _on-thread_ TypeScript environments for autocompletions
 * at this character.
 */
export function tsAutocomplete() {
    return async (context) => {
        const config = context.state.facet(tsFacet);
        if (!config)
            return null;
        return getAutocompletion({
            ...config,
            context,
        });
    };
}
//# sourceMappingURL=tsAutocomplete.js.map